<template>
    <div class="register_wrap">
        <div class="main_wrap">
            <el-page-header @back="$core.goBack" style="position:relative;left:-50px;top:-50px"></el-page-header>
            <div class="register_title"><i class="iconfont icon-shenhe">&nbsp;注册账号</i></div>
            <el-form class="register flex-between" :model="regForm" :rules="regRules" ref="regForm" label-width="130px">
                <div class="line">
                    <el-form-item prop="username" label="用户名:">
                        <div class="flex-between">
                            <el-input v-model="regForm.username" placeholder="请输入用户名"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="phone" label="手机号:">
                        <div class="flex-between">
                            <el-input v-model="regForm.phone" placeholder="请输入手机号" maxlength="11"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="gender" label="性别:">
                        <div class="flex-between">
                            <div class="select_label">
                                <el-select v-model="regForm.gender" placeholder="选择性别">
                                    <el-option v-for="item in genderList" :label="item.type" :value="item.id" :key="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item  label="出生年月:">
                        <div class="flex-between">
                            <div class="select_label">
                                <el-date-picker class="date-picker" v-model="regForm.birthday" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"  clearable></el-date-picker>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item prop="roleId" label="身份:">
                        <div class="flex-between">
                            <div class="select_label">
                                <el-select v-model="regForm.roleId" placeholder="选择身份" @change="selectEduTcth(),chancelValidate()">
                                    <el-option v-for="item in roleList" :label="item.type" :value="item.id" :key="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item prop="educationalLevel" label="教育层次:" v-if="regForm.roleId != teacherId && regForm.roleId != wokerId">
                        <div class="flex-between">
                            <div class="select_label">
                                <el-select v-model="regForm.educationalLevel" placeholder="选择教育层次" @change="selectEduTcth()">
                                    <el-option v-for="item in educationalLevelList" :label="item.type" :value="item.type" :key="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item prop="teachingLevel" label="教学层次:" v-if="regForm.roleId == teacherId">
                        <div class="flex-between">
                            <div class="select_label">
                                <el-select v-model="regForm.teachingLevel" placeholder="选择教育层次" @change="selectEduTcth()">
                                    <el-option v-for="item in teachingLevelList" :label="item.type" :value="item.type" :key="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item prop="workArea" label="工作领域:" v-if="regForm.roleId == wokerId">
                        <div class="flex-between">
                            <div class="select_label">
                                <el-select v-model="regForm.workArea" placeholder="选择工作领域">
                                    <el-option v-for="item in workAreaList" :label="item.type" :value="item.type" :key="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </el-form-item>
                    <div class="school_wrap" v-if="regForm.roleId != wokerId">
                        <div class="flex-between">
                            <el-form-item prop="provinceId" label="学校:">
                                <div class="flex-between">
                                    <el-select v-model="regForm.provinceId" placeholder="选择省份" @change="changeProvince()">
                                        <el-option v-for="item in provinceListL" :label="item.provinceName" :value="item.provinceId" :key="item.provinceId"></el-option>
                                    </el-select>
                                    <el-select v-model="regForm.cityId" placeholder="选择城市" @change="changeCity()">
                                        <el-option v-for="item in cityList" :label="item.cityName" :value="item.cityId" :key="item.cityId"></el-option>
                                    </el-select>
                                    <el-select v-model="regForm.schoolId" placeholder="选择学校">
                                        <el-option v-for="item in schoolList" :label="item.schoolName" :value="item.schoolId" :key="item.schoolId"></el-option>
                                    </el-select>
                                </div>
                            </el-form-item>
                        </div>
                        <el-form-item prop="schoolName" label="学校名称:" v-if="regForm.schoolId == -1">
                            <el-input v-model="regForm.schoolName" placeholder="请输入学校名称"></el-input>
                        </el-form-item>
                    </div>
                    <div class="flex-between" v-else>
                        <el-form-item prop="provinceId" label="工作城市:">
                            <div class="flex-between">
                                <el-select v-model="regForm.provinceId" placeholder="选择省份" @change="changeProvince()">
                                    <el-option v-for="item in provinceListL" :label="item.provinceName" :value="item.provinceId" :key="item.provinceId"></el-option>
                                </el-select>
                                <el-select v-model="regForm.cityId" placeholder="选择城市" >
                                    <el-option v-for="item in cityList" :label="item.cityName" :value="item.cityId" :key="item.cityId"></el-option>
                                </el-select>
                            </div>
                        </el-form-item>
                    </div>
                </div>
                <div class="line">
                    <el-form-item prop="collegeType" label="二级学院/系部:" v-if="isShowCollegeMAjor">
                        <div class="flex-between">
                            <el-input v-model="regForm.collegeType" placeholder="请输入二级学院/系部"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="workUnit" label="工作单位:" v-if="regForm.roleId == wokerId">
                        <div class="flex-between">
                            <el-input v-model="regForm.workUnit" placeholder="请输入工作单位"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="major" label="专业:" v-if="isShowCollegeMAjor">
                        <div class="flex-between">
                            <el-input v-model="regForm.major" placeholder="请输入专业"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="workDepartment" label="工作部门:" v-if="regForm.roleId == wokerId">
                        <div class="flex-between">
                            <el-input v-model="regForm.workDepartment" placeholder="请输入工作部门"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="researchDirection" label="研究方向:">
                        <div class="flex-between">
                            <div class="select_label">
                                <el-select v-model="regForm.researchDirection" placeholder="选择研究方向">
                                    <el-option v-for="item in researchDirectionList" :label="item.type" :value="item.type" :key="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </el-form-item>
                     <el-form-item prop="academicTile" label="职称:" v-if="regForm.roleId == teacherId">
                        <div class="flex-between">
                            <div class="select_label">
                                <el-select v-model="regForm.academicTile" placeholder="选择职称">
                                    <el-option v-for="item in academicTileList" :label="item.type" :value="item.type" :key="item.id"></el-option>
                                </el-select>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item prop="academicName" label="职称:" v-if="regForm.academicTile == '其它'">
                            <el-input v-model="regForm.academicName" placeholder="请输入职称"></el-input>
                    </el-form-item>
                    <el-form-item prop="password" label="密码设置:">
                        <div class="flex-between">
                            <el-input type="password" v-model="regForm.password" placeholder="请输入密码"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="rePassword" label="密码验证:">
                        <div class="flex-between">
                            <el-input type="password" v-model="regForm.rePassword" placeholder="请再次输入密码"></el-input>
                        </div>
                    </el-form-item>
                    <el-form-item prop="phoneVerifyCode" label="验证码:">
                        <div class="flex-between">
                            <el-input  v-model="regForm.phoneVerifyCode" placeholder="请输入验证码" ></el-input>
                            <el-button  size="medium" type="primary" @click="getverifyCode"  v-if="!isabled">获取验证码</el-button>
                            <el-button size="medium" type="info" plain v-else disabled>{{timer}}(s)后获取</el-button>
                        </div>
                    </el-form-item>
                </div>
            </el-form>
            <div>
                <el-checkbox v-model="isRead">我已阅读并同意 <span @click="agreementVisible = true" class="mouse-hover" style="color:#002D72">《平台用户隐私及使用协议》</span> </el-checkbox>
            </div>
            <div class="footer_btn flex-around">
                <el-button  class="submit" type="primary" @click="toRegister">注册</el-button>
                <el-button  @click="toLogin">使用已有账号登录</el-button>
            </div>
        </div>
        <!-- 验证码弹窗 -->
        <el-dialog :visible.sync="tipsShow" width="25%" top="10%" center class="dialog2">
           <div class="tips_wrap">请先输入图中验证码以验证身份</div>
           <div class="tips_wrap" @click="getverifyCode"><img :src="verifyCodeUrl" style="cursor: pointer;" title="看不清？换一张"/></div>
           <div class="tips_wrap flex-between"><el-input v-model="verifycontent" placeholder="请输入验证码"></el-input><el-button type="primary" @click="submitCode">提交</el-button></div>
       </el-dialog>
       <!-- 用户协议 -->
       <el-dialog :visible.sync="agreementVisible" width="50%" :show-close="false" class="dialog_wrap" top="5%" center>
            <div class="agreement_dialog">
                <div  class="agreement_title">平台用户<span style="color:#F56C6C">知识产权与隐私安全协议</span> </div>
                <p>尊敬的用户，您好！您现在阅读的是<span style="color:#F56C6C">平台用户知识产权与隐私安全使用协议</span> ，根据本协议的规定为平台用户提供服务，本协议具有合同上的法律效力。<b>用户在注册或使用平台前请务必仔细阅读以下条款，一经注册或主动使用本网站的服务，即视为对本协议全部条款已充分理解并完全接受，且自愿受以下条款的约束。</b> 该平台所属公司有权根据新的需要，<b>修改或调整</b>部分协议条款，如本协议及规则有任何变更，将会及时<b>更新公布最新协议</b>，若用户不同意相关变更，应主动停止使用本平台的服务。<b>该平台知识产权属成都麦思多维科技有限公司所有</b>。</p>
                <div class="one_title"><b>一、平台对用户信息与隐私保护</b></div>
                <p>为了给您提供更准确、更有针对性的服务，本平台可能会以如下方式，使用您提交的个人信息。但本平台会以高度的勤勉义务对待这些信息，在未征得您许可的情况下，不会将这些信息对外公开或向第三方提供。</p>
                <div class="two_title"><b>1.个人信息与账号安全</b></div>
                <p>本平台需要您在自愿选择服务的情况下提供个人信息，以便向您提供更好的用户服务。所有原始键入的信息将引用为注册资料。如果因注册信息不真实而引起的问题，由您自行承担相应的后果。<b>禁止将您的帐号、密码，未经本公司许可，转让或出借予他人使用</b> 。如您发现您的帐号遭他人非法使用，应立即通知本平台。因黑客行为或用户的保管疏忽导致帐号、密码遭他人非法使用，本平台不承担责任。</p>
                <div class="two_title"><b>2.行为信息与使用记录</b></div>
                <p>当您使用本平台的服务时，服务器会自动记录一些用户使用信息，本软件均会遵照法律规定保护您的个人隐私信息，除可能脱敏使用数据分析供科研与教学用途外，不会与任何第三方平台进行个人信息商业交易和对外公开。</p>
                <div class="one_title">二、用户对平台知识产权保护</div>
                <p>自用户使用该平台起，自动就该平台使用及知识产权保护达成如下协议：</p>
                <p>1.用户承诺合法使用本平台提供的服务及网站内容，禁止从事任何可能违反中国现行的法律、法规、规章和政府规范性文件的行为或任何未经授权使用本平台的行为。</p>
                <p>2.用户在用户账号授权时间及范围内使用，支持用户进行科研、教学自主研究，不得在未经平台所属公司授权情况下用于商业用途。本平台所属公司保留中止或终止用户身份的权利。</p>
                <p>3.用户在使用该平台期间，不得以任何形式将平台技术及产权内容纰漏给第三方，不能有任何损害平台利益的情况发生。</p>
                <p>4.用户未经平台所属公司同意，不得将本人所拥有的平台账号及密码转让给第三方或授权给第三方使用。</p>
                <p><span style="color:#409EFF">如果您对以上协议的任何内容有任何疑问或建议，您可以通过服务支持邮箱msdw@maxsdsp.com </span> 或 微信公众号：麦思多维研究院  与我们联系。</p>
            </div>
            <div slot="footer" class="flex-around">
                <el-button @click="agreementVisible = false" type="primary">我已阅读</el-button>
            </div>
       </el-dialog>
    </div>
</template>

<script>
import {getProvince,getCity,getSchool,checkAndSendSMS,register,getImage} from '../../../utils/api'
import {genderList,roleList,educationalLevelList,teachingLevelList,researchDirectionList,workAreaList,academicTileList,regForm,regRules} from '../../../utils/commonData'
export default {
    data () {
        return {
            // 全局定义老师学生id，防止修改
            agreementVisible:false,
            isRead:false,
            studentId:1,
            teacherId:2,
            wokerId:3,
            tipsShow:false,
            isabled:false,
            timer:60,
            verifyCodeUrl:'',
            verifycontent:'',
            uuid:'',
            isShowCollegeMAjor:true,//教学教育层次为小初高和角色为在职人员则不展示二级学院和专业
            // 性别选择
            genderList:JSON.parse(JSON.stringify(genderList)),
            // 角色选择
            roleList:JSON.parse(JSON.stringify(roleList)),
            // 教育层次（学生、待岗、退休）
            educationalLevelList:JSON.parse(JSON.stringify(educationalLevelList)),
            // 教学层次（老师）
            teachingLevelList:JSON.parse(JSON.stringify(teachingLevelList)),
            // 研究方向
            researchDirectionList:JSON.parse(JSON.stringify(researchDirectionList)),
            // 工作领域（在职人员）
            workAreaList:JSON.parse(JSON.stringify(workAreaList)),
            // 职称（教师）
            academicTileList:JSON.parse(JSON.stringify(academicTileList)),
            // 表单对象
            regForm:{
                username:'',
                phone:'',
                gender:'',
                birthday:'',
                roleId:1,
                educationalLevel:'',
                teachingLevel:'',
                provinceId:'',
                cityId:'',
                schoolId:'',
                schoolName:'',
                collegeType:'',
                major:'',
                researchDirection:'',
                academicTile:'',
                academicName:'',
                workArea:'',
                workUnit:'',
                workDepartment:'',
                password:'',
                rePassword:'',
                phoneVerifyCode:'',
            },
            // 校验规则
            regRules:{
                username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
                phone: [{ required: true, message: '请输入11位手机号', trigger: 'blur' },
                        { pattern: `^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\\d{8}$`, message: '请输入正确手机格式', trigger: 'blur' }],
                gender: [{ required: true, message: '请选择性别', trigger: 'blur' }],
                birthday: [{ required: true, message: '请输入出生年月', trigger: 'blur' }],
                roleId: [{ required: true, message: '请选择身份', trigger: 'blur' }],
                educationalLevel: [{ required: true, message: '请选择教育层次', trigger: 'blur' }],
                teachingLevel: [{ required: true, message: '请选择教学层次', trigger: 'blur' }],
                provinceId: [{ required: true, message: '请选择学校所在省', trigger: 'blur' }],
                cityId: [{ required: true, message: '请选择学校所在市', trigger: 'blur' }],
                schoolId: [{ required: true, message: '请选择所在学校', trigger: 'blur' }],
                schoolName: [{ required: true, message: '请填写学校名称', trigger: 'blur' }],
                collegeType:[{ required: true, message: '请填写所在学院/系', trigger: 'blur' }],
                major:[{ required: true, message: '请选择所在专业', trigger: 'blur' }],
                researchDirection:[{ required: true, message: '请选择研究方向', trigger: 'blur' }],
                academicTile:[{ required: true, message: '请选择职称', trigger: 'blur' }],
                academicName:[{ required: true, message: '请选择职称', trigger: 'blur' }],
                workArea:[{ required: true, message: '请选择工作领域', trigger: 'blur' }],
                workUnit:[{ required: true, message: '请选择工作单位', trigger: 'blur' }],
                workDepartment:[{ required: true, message: '请选择工作部门', trigger: 'blur' }],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { pattern: /^.{8,}$/, message: '请输入8-16位密码，区分大小写', trigger: 'blur' }
                ],
                rePassword: [
                    { required: true, message: '请再次输入密码', trigger: 'blur' },
                    { pattern: /^.{8,}$/, message: '请输入8-16位密码，区分大小写', trigger: 'blur' }
                ],
                phoneVerifyCode:[{ required: true, message: '请输入验证码', trigger: 'blur' }],
            },
            provinceListL:[],
            cityList:[],
            schoolList:[]
        }
    },
    created(){
        this.chancelValidate()
        this.getProvinceList()
    },
    computed:{},
    methods:{
        // 教学教育层次改变
        selectEduTcth(){
            let { teachingLevel, educationalLevel, roleId } = this.regForm
            this.isShowCollegeMAjor = this.$core.isShowCollegeMAjor(teachingLevel, educationalLevel,roleId)
        },
        // 注册
        toRegister(){
            if(!this.isRead) return this.$message.error('请先阅读知识产权与隐私安全协议！')
            // 如果职称有内容且选择“其它”时，将输入框的值(academicName)赋予(academicTile)
            this.regForm.academicTile = this.regForm.academicName ? this.regForm.academicName : this.regForm.academicTile
            this.chancelValidate()
            this.$refs.regForm.validate(async valid => {
                if (!valid) return;
                if(this.regForm.password != this.regForm.rePassword){
                    return this.$message.error('两次密码输入不一致!')
                }
                register(this.regForm).then(res => {
                    this.$confirm('注册成功, 是否立即登录?', '恭喜', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'success'
                    }).then(() => {
                       this.$router.push('/login')
                    }).catch(() => {});
                }).catch(err => {})
            })
        },

        // 前往登录页
        toLogin(){
            this.$router.push('/login')
        },

        // 根据角色取消校验
        chancelValidate(){
            // 取消校验
            let studentArr = ["major","researchDirection"] //学生
            let teacherArr = ["major","researchDirection","academicTile"] //老师
            let workerArr = ["workDepartment","researchDirection"] //在职人员
            let otherArr = ["major","collegeType","researchDirection","provinceId","cityId","schoolId"]  //待岗、退休

            // 角色填写注册表单过程突然修改角色
            let studentClear = ["teachingLevel","academicTile","workArea","workUnit","workDepartment"]  //学生、退休、待岗
            let teacherClear = ["educationalLevel","workArea","workUnit","workDepartment"]  //老师
            let workerClear = ["educationalLevel","teachingLevel","schoolId","schoolName","collegeType","major","academicTile"]  //在职人员

            // 表单所有键key
            let totalRulesArr = Object.keys(this.regRules)

            // 判断前先将校验规则（是否校验）回归
            totalRulesArr.forEach(item => {
                this.regRules[item][0].required = true
            }) 
            switch(this.regForm.roleId){
                // 学生
                case 1:
                    studentArr.forEach(item => {
                        this.regRules[item][0].required = false
                    })
                    studentClear.forEach(item => {
                        this.regForm[item] = ''
                    })
                    break;
                // 老师
                case 2:
                    teacherArr.forEach(item => {
                        this.regRules[item][0].required = false
                    })
                    teacherClear.forEach(item => {
                        this.regForm[item] = ''
                    })
                    break;
                // 在职
                case 3:
                    workerArr.forEach(item => {
                        this.regRules[item][0].required = false
                    })
                    workerClear.forEach(item => {
                        this.regForm[item] = ''
                    })
                    break;
                // 待岗、退休
                case 4:
                case 5:
                    otherArr.forEach(item => {
                         this.regRules[item][0].required = false
                    })
                    studentClear.forEach(item => {
                        this.regForm[item] = ''
                    })
                    break;
            }
        },

        // 点击获取图形验证码
        getverifyCode(){
            getImage().then(res => {
                this.verifyCodeUrl = res.data.image
                this.uuid = res.data.uuid_verify
                //清空输入框
                this.verifycontent = ''
            }).catch(err =>　{})
            this.tipsShow = true
        },

        // 提交图形验证码并发送手机验证码
        submitCode(){
            if(!this.regForm.phone || !this.verifycontent){
                return this.$message.error('请先输入手机号与图形验证码')
            }
            checkAndSendSMS(`${this.regForm.phone}/${this.verifycontent}/${this.uuid}`).then(res => {
                this.tipsShow = false
                this.$message.success('验证通过，请查收手机验证码')
                // 手机验证码发送成功后禁用
                let interval = setInterval(() => {
                    let obj =  this.$core.virifyCode(this.timer)
                    this.timer = obj.timer
                    this.isabled = obj.isabled
                    if(!obj.isabled){
                        this.timer = 60
                        clearInterval(interval)
                    }
                },1000)
            }).catch(err => {
                this.getverifyCode()
            })
        },

        // 获取省份
        getProvinceList(){
            getProvince().then(res => {
                this.provinceListL = res.data
            }).catch(err => {})
        },

        //改变省
        changeProvince(){
            this.getCityList()
            this.regForm.cityId = ''
            this.regForm.schoolId = ''
        },

        // 获取城市列表
        getCityList(){
            getCity(`${this.regForm.provinceId}`).then(res => {
                this.cityList = res.data
            }).catch(err => {})
        },

        //改变市
        changeCity(){
            this.getSchoolList()
            this.regForm.schoolId = ''
        },

        //获取学校列表
        getSchoolList(){
            getSchool(`${this.regForm.provinceId}/${this.regForm.cityId}`).then(res => {
                this.schoolList = res.data
                let obj = {schoolId:-1 , schoolName:"其它"}
                this.schoolList.push(obj)
            }).catch(err => {})
        }
    }
}
</script> 

<style lang='scss' scoped>
.dialog_wrap{
    /deep/.el-dialog{
        border-radius: 10px;
        overflow: hidden;
    }
    /deep/.el-dialog__header{
        padding: 0px;
    }
    }

.agreement_dialog{
    line-height: 1.7;
    font-size: 18px;
    max-height: 70vh;
    overflow-y: auto;
    padding: 20px 50px;
    .agreement_title{
        font-size: 25px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 20px;
    }
    .one_title{
        margin: 10px 0px;
    }
    p{
        text-indent: 2rem;
    }
}
/deep/ .el-form-item__label{
    color: #606266;
}
.dialog2{
    /deep/ .el-dialog{
        height: 35%;
        padding: 0 30px;
        text-align: center;
        display: flex;
        align-items: center;
        .tips_wrap{
            width: 100%;
            margin: 30px 0;
            font-size: 20px;
            font-weight: bold;
            text-align: center;
        }
    }
}
.register_wrap{
    height: 100vh;
    width: 100%;
    overflow-y: hidden;
    background: url(../../../assets/img/MS-A/regBg.png) 0 0/100% 100% no-repeat;
    .main_wrap {
        /deep/ .el-input__inner{
            background-color: white;
        }
        /deep/ .el-textarea__inner{
            background-color: white;
        }
        position: relative;
        left: 27vw;
        top: 10vh;
        width: 50%;
        padding:50px 100px;
        // background: #F2F4F9;
        border-radius: 15px;
        // background: rgba(255, 255, 255, 0.39);
        .register_title{
            text-align: center;
            margin-bottom: 40px;
            .icon-shenhe{
                font-size: 30px;
                color: #333333;
                letter-spacing: 2px;
                font-weight: bold;
            }
        }
        .register{
            width: 100%;
            .line{
                width: 47%;
                .select_label{
                    width: 100%;
                }
                .date-picker{
                    width: 100% ;
                }
            }
        }

        .footer_btn{
            padding: 0 20%;
            margin-top: 30px;
            /deep/ .el-button{
                width: 29%;
            }
        }
    }
}
</style>